import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/attack';

/** 状況 `attack_monster`（組み立ては `../fx/attack.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'attack_monster', role: 'effect', ...spec }, 'attack_monster_effect.js');
